// extracted by mini-css-extract-plugin
export default {"column":"suggest_tag_form__column__JARgJ"};